<template>
  <el-card>
    <div slot="header">
      <h1>订单列表</h1>
    </div>
    <el-form inline :model="query" class="filter-form">
      <el-form-item label="订单号">
        <el-input v-model.trim="query.orderSn" placeholder="订单号" />
      </el-form-item>
      <el-form-item label="收件人/电话">
        <el-input v-model.trim="query.consignee" placeholder="收件人/电话" />
      </el-form-item>
      <el-form-item label="下单人">
        <el-input v-model.trim="memberQuery.account" placeholder="下单人" />
      </el-form-item>
      <el-form-item label="商品名称/编码">
        <SpecPicker
          v-model.trim="orderProductQuery.sku"
          action="product-specs"
          labelField=""
          valueField=""
          keywordField="name"
          _placeholder="商品名或sku">
        </SpecPicker>
      </el-form-item>
      <el-form-item v-for="statusField in statusFields" :label="statusField.label">
        <el-select v-model="query[statusField.field]" clearable placeholder="请选择">
          <el-option
            v-for="item in $enums[statusField.field].getList()"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间">
        <el-date-picker
          v-model="query.createdAt"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="内购活动">
        <el-select v-model="query.activityId" clearable filterable
                   :remote-method="remoteMethod"
                   placeholder="请选择">
          <el-option
            v-for="item in activities"
            :key="item.id"
            :label="item.activityName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table class="table block" v-loading="loading" :data="collection">
      <el-table-column label="订单号">
        <template slot-scope="scope">
          <p>
            <!-- <router-link :to="{name: 'order-detail'}" :params="{ id: scope.row.id }">
              {{scope.row.orderSn}}
            </router-link> -->

            <a class="text-blue">{{scope.row.orderSn}}</a>
            <i
              class="el-icon-document-copy"
              style="color:#1890ff;margin-left:10px"
              @click="copy(scope.row.orderSn)"
            ></i>
          </p>
          <p>{{scope.row.createdAt}}</p>
        </template>
      </el-table-column>
      <el-table-column label="下单人">
        <template slot-scope="scope">
          <p>{{scope.row.member.account}}</p>
        </template>
      </el-table-column>
      <el-table-column label="所属活动">
        <template slot-scope="scope">
          <p>{{ (scope.row.activity && scope.row.activity.activityName) || '-' }}</p>
        </template>
      </el-table-column>
      <el-table-column label="收件人">
        <template slot-scope="scope">
          <p>{{scope.row.consignee}}</p>
          <p>{{scope.row.region}} {{scope.row.address}}</p>
           <p>{{scope.row.mobile}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="orderStatus" label="订单状态" :formatter="$tableHelper.fmts.enums.orderStatus" />
      <el-table-column prop="payStatus" label="支付状态" :formatter="$tableHelper.fmts.enums.payStatus" />
      <el-table-column prop="shippingStatus" label="发货状态" :formatter="$tableHelper.fmts.enums.shippingStatus" />
      <el-table-column label="订单商品">
        <template slot-scope="scope">
          <p v-for="(orderProduct, index) in scope.row.orderProducts" :key="index">
            {{orderProduct.productName}}
            <divider v-if="scope.row.orderProducts.length > 1 && index != scope.row.orderProducts.length - 1" />
          </p>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
    <input
      type="text"
      ref="copySn"
      id="copySn"
      style="display: block;position: absolute;z-index: -10;"
      v-bind:value="copySn"
    >
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
import SpecPicker from "@/components/SpecPicker";

const { mapGetters } = createNamespacedHelpers('orders')
const { mapGetters: mapActivitiesGetters } = createNamespacedHelpers('activities')

export default {
  data() {
    return {
      loading: false,
      query: {
        orderSn: '',
        consignee: '',
        createdAt: [],
      },
      orderProductQuery: {
        sku: ''
      },
      memberQuery: {
         account: ''
      },
      statusFields: [
        {
          label: '订单状态',
          field: 'orderStatus'
        },
        {
          label: '支付状态',
          field: 'payStatus'
        },
        {
          label: '发货状态',
          field: 'shippingStatus'
        }
      ],
      copySn: '',
    }
  },
  components: {
    SpecPicker
  },
  computed: {
    ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
    ...mapActivitiesGetters({ activities: 'collection' })
  },
  methods: {
    remoteMethod() {
      console.log('called')
    },
    async queryCollection({ pagination = {} } = {}) {
      const query = {
        ...this.query,
        createdAt: this.$queryHelper.formatDateRange(this.query.createdAt)
      }
      const orderProductQuery = {
        ...this.orderProductQuery
      }
      const memberQuery = {
        account: `%${this.memberQuery.account}%`
      }
      try {
        this.loading = true
        await this.$store.dispatch('orders/collection', { query, relsQuery: { orderProducts: orderProductQuery, member: memberQuery }, pagination })
      } finally {
        this.loading = false
      }
    },
    async remove(orders) {
      await this.$confirm('确认要删除此商品？')
      await this.$store.dispatch('orders/remove', orders)
      await this.queryCollection()
      this.$message.success('商品删除操作完成')
    },
    // 复制
    copy(sn) {
      this.copySn = sn;
      this.$nextTick(() => {
        var copySn = this.$refs.copySn;
        copySn.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.success('复制成功')
      })
    },
  },
  mounted() {
    this.$store.dispatch('activities/collection', { pagination: {limit: 200} })
    this.queryCollection()
  },
  activated() {
    this.queryCollection()
  }
}
</script>
